class Navigation extends ViewBasic {
	constructor(options) {
		super(options);

		this.options = {
			'class': {
				'open': 'open',
				'close': 'close',
				'scrollDisable': 'no-scroll',
				'isAnimating': 'during-animation'
			}
		};

		this.$mobileTrigger = this.$('.burger-btn');
		this.$elMenuAnimated = this.$('.wrapper-mobile-expand');
		this.$html = $('html');

		this.addEvents();
	}


	addEvents() {
		//Event
		this.$mobileTrigger.on('click', (e) => this.handlePanel(e));
        $(window).scroll(e => this.scrollHandler(e));

		this.$('.primary-cta.order-online').on('click', (e) => this.orderClickHandler(e));

		//All subscribe
		Me.dispatch.subscribe('breakpointChanged', $.proxy(this.breakpointHadler, this));
	}

	removeEvents() {

	}

    scrollHandler() {
        if ($(window).width() > SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN) {
        	if ($(window).scrollTop() > 70 && !this.$el.hasClass('collapsed')) {
                this.$el.addClass('collapsed');
        	} else if($(window).scrollTop() <= 70 && this.$el.hasClass('collapsed')){
                this.$el.removeClass('collapsed');
			}
        }
    }

	handlePanel(e){
		e.preventDefault();

		if(this.isAnimated){return;}
		this.isAnimated = true;

		this.$el.addClass(this.options.class.isAnimating);
		this.$elMenuAnimated.slideToggle(500, e => {this.isAnimated = false;this.$el.removeClass(this.options.class.isAnimating);});

		if(this.$el.hasClass(this.options.class.open)){
			this.$el.removeClass(this.options.class.open).addClass(this.options.class.close);
			this.$html.removeClass(this.options.class.scrollDisable);
		} else{
			this.$el.removeClass(this.options.class.close).addClass(this.options.class.open);
			this.$html.addClass(this.options.class.scrollDisable);
		}
	}

	resetDisplay(){
		this.$el.removeClass(this.options.class.open + " " + this.options.class.close);
		this.$html.removeClass(this.options.class.scrollDisable);
		this.$elMenuAnimated.removeAttr('style');
	}

	orderClickHandler(e){
		
        Me.track.event("Header", "Order online", $(e.currentTarget).attr('href'));
        fbq('track', 'ViewContent');
	}

	breakpointHadler(e, params){
		if(Me.help.dimension.getTotalW() > 767){
			this.resetDisplay();
		}
	}
}